import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { ConditionalRouterLinkDirective } from '@zaoblako/web/shared/directives/conditional-router-link.directive';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'crm-created-projects-widget',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TableComponent,
    TagModule,
    ButtonModule,
    SpinnerComponent,
    ConditionalRouterLinkDirective
  ],
  templateUrl: './created-projects-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreatedProjectsWidgetComponent {
  @Input() public loading: boolean;
  @Input() public projects: ProjectFindInterface[];

  @Output() public directToProjectList = new EventEmitter<void>();

  public columns: CrmTableColumn[] = [{ label: 'Название' }, { label: 'Дата' }];

  public toProject(project: any): ProjectFindInterface {
    return project as ProjectFindInterface;
  }
}
